/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './describeFeedGenerator.defs.js'
export { main as default } from './describeFeedGenerator.defs.js'
